import React, { useRef, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import styles from "../DashboardFileManagement.module.css"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const options = {
    responsive: true,
    plugins: {
        legend: {
            display: false,
            position: 'top',
        },
        title: {
            display: false,
            text: 'Chart.js Line Chart',
        },
        scales: {
            y: {
                display: false
            }
        },
        setSumTotal: false
    },
    scales: {
        y: {
            grid: {
                display: false
            }
        },
        x: {
            grid: {
                display: false
            }
        }
    }
};


const CardChart = ({ data }) => {
    const chartRef = useRef(null);
    useEffect(() => {
        if (chartRef && chartRef.current) {
            // Unregister the setSumTotal plugin before destroying the chart
            ChartJS.unregister(ChartDataLabels);
            ChartJS.unregister("setSumTotal");
            const chartInstance = chartRef.current.chartInstance;
            if (chartInstance) {
                chartInstance.destroy();
            }
        }
    }, [data]);

    if (data.labels == "") {
        return <div className={`mt-2 mb-3 ${styles.rent_title}`}>تاکنون هیچ تغییر قیمتی ثبت نشده است.</div>;
    }

    return <Line ref={chartRef} options={options} data={data} />;
};

export default CardChart;